import { render, staticRenderFns } from "./PiechartWidget.vue?vue&type=template&id=32e3aee3"
import script from "./PiechartWidget.vue?vue&type=script&lang=js"
export * from "./PiechartWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports